// extracted by mini-css-extract-plugin
module.exports = {"OnePictureDe":"OnePictureDe_OnePictureDe__X4XzV"};